import React from "react";

export const EmailIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_68_2558)">
      <path
        d="M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3ZM20 7.238L12.072 14.338L4 7.216V19H20V7.238ZM4.511 5L12.061 11.662L19.502 5H4.511Z"
        fill="#2977CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_68_2558">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const ArrowIconWhite = () => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_62_2299)">
      <path
        d="M9.5 10.7917V16.3334L15.8333 10.0001L9.5 3.66675V9.20841H3.16667V10.7917H9.5Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_62_2299">
        <rect
          width="19"
          height="19"
          fill="white"
          transform="matrix(-1 0 0 1 19 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const PasswordIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H6V7C6 5.4087 6.63214 3.88258 7.75736 2.75736C8.88258 1.63214 10.4087 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7V8ZM5 10V20H19V10H5ZM11 14H13V16H11V14ZM7 14H9V16H7V14ZM15 14H17V16H15V14ZM16 8V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V8H16Z"
      fill="#2977CC"
    />
  </svg>
);
export const PasswordEyeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_10_8499)">
<path d="M12 3C17.392 3 21.878 6.88 22.819 12C21.879 17.12 17.392 21 12 21C6.608 21 2.122 17.12 1.181 12C2.121 6.88 6.608 3 12 3ZM12 19C14.0395 18.9996 16.0184 18.3068 17.6129 17.0352C19.2073 15.7635 20.3229 13.9883 20.777 12C20.3212 10.0133 19.2049 8.24 17.6106 6.97003C16.0163 5.70005 14.0383 5.00853 12 5.00853C9.9617 5.00853 7.98369 5.70005 6.38938 6.97003C4.79506 8.24 3.67877 10.0133 3.223 12C3.6771 13.9883 4.79267 15.7635 6.38714 17.0352C7.98161 18.3068 9.96053 18.9996 12 19ZM12 16.5C10.8065 16.5 9.66193 16.0259 8.81802 15.182C7.97411 14.3381 7.5 13.1935 7.5 12C7.5 10.8065 7.97411 9.66193 8.81802 8.81802C9.66193 7.97411 10.8065 7.5 12 7.5C13.1935 7.5 14.3381 7.97411 15.182 8.81802C16.0259 9.66193 16.5 10.8065 16.5 12C16.5 13.1935 16.0259 14.3381 15.182 15.182C14.3381 16.0259 13.1935 16.5 12 16.5ZM12 14.5C12.663 14.5 13.2989 14.2366 13.7678 13.7678C14.2366 13.2989 14.5 12.663 14.5 12C14.5 11.337 14.2366 10.7011 13.7678 10.2322C13.2989 9.76339 12.663 9.5 12 9.5C11.337 9.5 10.7011 9.76339 10.2322 10.2322C9.76339 10.7011 9.5 11.337 9.5 12C9.5 12.663 9.76339 13.2989 10.2322 13.7678C10.7011 14.2366 11.337 14.5 12 14.5Z" fill="#97999B"/>
</g>
<defs>
<clipPath id="clip0_10_8499">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

  // <svg
  //   width="24"
  //   height="24"
  //   viewBox="0 0 24 24"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <g clip-path="url(#clip0_77_448)">
  //     <path
  //       d="M9.99999 2.5C14.4933 2.5 18.2317 5.73333 19.0158 10C18.2325 14.2667 14.4933 17.5 9.99999 17.5C5.50666 17.5 1.76833 14.2667 0.984161 10C1.76749 5.73333 5.50666 2.5 9.99999 2.5ZM9.99999 15.8333C11.6996 15.833 13.3486 15.2557 14.6774 14.196C16.0061 13.1363 16.9357 11.6569 17.3142 10C16.9344 8.34442 16.0041 6.86667 14.6755 5.80835C13.3469 4.75004 11.6986 4.17377 9.99999 4.17377C8.30141 4.17377 6.65307 4.75004 5.32447 5.80835C3.99588 6.86667 3.06563 8.34442 2.68583 10C3.06424 11.6569 3.99389 13.1363 5.32261 14.196C6.65134 15.2557 8.30044 15.833 9.99999 15.8333ZM9.99999 13.75C9.00543 13.75 8.05161 13.3549 7.34834 12.6516C6.64508 11.9484 6.24999 10.9946 6.24999 10C6.24999 9.00544 6.64508 8.05161 7.34834 7.34835C8.05161 6.64509 9.00543 6.25 9.99999 6.25C10.9946 6.25 11.9484 6.64509 12.6516 7.34835C13.3549 8.05161 13.75 9.00544 13.75 10C13.75 10.9946 13.3549 11.9484 12.6516 12.6516C11.9484 13.3549 10.9946 13.75 9.99999 13.75ZM9.99999 12.0833C10.5525 12.0833 11.0824 11.8638 11.4731 11.4731C11.8638 11.0824 12.0833 10.5525 12.0833 10C12.0833 9.44747 11.8638 8.91756 11.4731 8.52686C11.0824 8.13616 10.5525 7.91667 9.99999 7.91667C9.44746 7.91667 8.91756 8.13616 8.52685 8.52686C8.13615 8.91756 7.91666 9.44747 7.91666 10C7.91666 10.5525 8.13615 11.0824 8.52685 11.4731C8.91756 11.8638 9.44746 12.0833 9.99999 12.0833Z"
  //       fill="#97999B"
  //     />
  //   </g>
  //   <defs>
  //     <clipPath id="clip0_77_448">
  //       <rect width="24" height="24" fill="white" />
  //     </clipPath>
  //   </defs>
  // </svg>
);

export const PasswordEyeIconOff = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_10_8447)">
      <path
        d="M17.882 19.2971C16.1232 20.4126 14.0827 21.0034 12 21.0001C6.608 21.0001 2.122 17.1201 1.181 12.0001C1.61103 9.67078 2.78263 7.54296 4.521 5.93407L1.392 2.80807L2.807 1.39307L22.606 21.1931L21.191 22.6071L17.881 19.2971H17.882ZM5.935 7.35007C4.576 8.58566 3.62932 10.2088 3.223 12.0001C3.53529 13.3665 4.16226 14.6412 5.054 15.7227C5.94574 16.8041 7.07763 17.6625 8.35955 18.2294C9.64148 18.7963 11.038 19.0561 12.4381 18.9882C13.8381 18.9203 15.203 18.5264 16.424 17.8381L14.396 15.8101C13.5327 16.3539 12.5102 16.5882 11.4962 16.4745C10.4823 16.3608 9.53704 15.906 8.81557 15.1845C8.0941 14.463 7.63923 13.5178 7.52556 12.5038C7.4119 11.4899 7.64618 10.4674 8.19 9.60407L5.935 7.35007ZM12.914 14.3281L9.672 11.0861C9.49406 11.539 9.45219 12.034 9.55151 12.5104C9.65082 12.9868 9.88702 13.4238 10.2311 13.7679C10.5752 14.1121 11.0123 14.3482 11.4887 14.4476C11.965 14.5469 12.4601 14.505 12.913 14.3271L12.914 14.3281ZM20.807 16.5921L19.376 15.1621C20.0445 14.2094 20.5204 13.1353 20.777 12.0001C20.5052 10.8098 19.9943 9.68721 19.2751 8.70056C18.556 7.71391 17.6438 6.88379 16.5939 6.26067C15.544 5.63755 14.3783 5.23443 13.1677 5.07583C11.9572 4.91723 10.727 5.00645 9.552 5.33807L7.974 3.76007C9.221 3.27007 10.58 3.00007 12 3.00007C17.392 3.00007 21.878 6.88007 22.819 12.0001C22.5126 13.6658 21.8239 15.2376 20.807 16.5921ZM11.723 7.50807C12.3595 7.46873 12.9971 7.56513 13.5935 7.79088C14.19 8.01663 14.7316 8.36658 15.1825 8.81752C15.6335 9.26846 15.9834 9.81009 16.2092 10.4065C16.4349 11.003 16.5313 11.6406 16.492 12.2771L11.722 7.50807H11.723Z"
        fill="#97999B"
      />
    </g>
    <defs>
      <clipPath id="clip0_10_8447">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const YesTickIcon = () => (
  <svg
    width="7"
    height="7"
    viewBox="0 0 7 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.39062 0C1.52578 0 0 1.575 0 3.5C0 5.425 1.52578 7 3.39062 7C5.25547 7 6.78125 5.425 6.78125 3.5C6.78125 1.575 5.25547 0 3.39062 0ZM2.7125 5.25L1.01719 3.5L1.49188 3.01L2.7125 4.27L5.28938 1.61L5.76406 2.1L2.7125 5.25Z"
      fill="#3DC826"
    />
  </svg>
);
export const NoTickIcon = () => (
  <svg
    width="7"
    height="7"
    viewBox="0 0 7 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 0C2.80777 0 2.13108 0.205271 1.55551 0.589856C0.979933 0.974441 0.53133 1.52107 0.266423 2.16061C0.00151651 2.80015 -0.0677952 3.50388 0.0672531 4.18282C0.202301 4.86175 0.535644 5.48539 1.02513 5.97487C1.51461 6.46436 2.13825 6.7977 2.81718 6.93275C3.49612 7.06779 4.19985 6.99848 4.83939 6.73358C5.47893 6.46867 6.02556 6.02007 6.41014 5.44449C6.79473 4.86892 7 4.19223 7 3.5C7 2.57174 6.63125 1.6815 5.97487 1.02513C5.3185 0.368749 4.42826 0 3.5 0ZM4.99768 4.54777C5.02807 4.57712 5.05231 4.61223 5.06899 4.65105C5.08566 4.68987 5.09444 4.73162 5.09481 4.77387C5.09517 4.81612 5.08712 4.85802 5.07113 4.89712C5.05513 4.93622 5.0315 4.97175 5.00163 5.00162C4.97175 5.0315 4.93622 5.05513 4.89712 5.07112C4.85802 5.08712 4.81612 5.09517 4.77387 5.09481C4.73162 5.09444 4.68987 5.08566 4.65105 5.06899C4.61223 5.05231 4.57712 5.02807 4.54777 4.99768L3.5 3.94991L2.45223 4.99768C2.42288 5.02807 2.38777 5.05231 2.34895 5.06899C2.31013 5.08566 2.26838 5.09444 2.22613 5.09481C2.18388 5.09517 2.14198 5.08712 2.10288 5.07112C2.06378 5.05513 2.02825 5.0315 1.99838 5.00162C1.9685 4.97175 1.94487 4.93622 1.92888 4.89712C1.91288 4.85802 1.90483 4.81612 1.90519 4.77387C1.90556 4.73162 1.91434 4.68987 1.93101 4.65105C1.94769 4.61223 1.97193 4.57712 2.00232 4.54777L3.05009 3.5L2.00232 2.45223C1.97193 2.42288 1.94769 2.38777 1.93101 2.34895C1.91434 2.31013 1.90556 2.26838 1.90519 2.22613C1.90483 2.18388 1.91288 2.14198 1.92888 2.10288C1.94487 2.06377 1.9685 2.02825 1.99838 1.99837C2.02825 1.9685 2.06378 1.94487 2.10288 1.92887C2.14198 1.91288 2.18388 1.90483 2.22613 1.90519C2.26838 1.90556 2.31013 1.91434 2.34895 1.93101C2.38777 1.94769 2.42288 1.97193 2.45223 2.00232L3.5 3.05009L4.54777 2.00232C4.57712 1.97193 4.61223 1.94769 4.65105 1.93101C4.68987 1.91434 4.73162 1.90556 4.77387 1.90519C4.81612 1.90483 4.85802 1.91288 4.89712 1.92887C4.93622 1.94487 4.97175 1.9685 5.00163 1.99837C5.0315 2.02825 5.05513 2.06377 5.07113 2.10288C5.08712 2.14198 5.09517 2.18388 5.09481 2.22613C5.09444 2.26838 5.08566 2.31013 5.06899 2.34895C5.05231 2.38777 5.02807 2.42288 4.99768 2.45223L3.94991 3.5L4.99768 4.54777Z"
      fill="#E11D48"
    />
  </svg>
);
